import type { MouseEvent } from "react";
import { renderInvitationContent } from "./invitationEmail";
import styles from "./EmailPreview.module.css";

// The links in the preview point to a survey that does not exist yet, so clicks (and Enter) do nothing.
const preventLinkClick = (event: MouseEvent) => {
  if ((event.target as Element).closest("a")) event.preventDefault();
};

// The same template as the e-mail the server sends (invitationEmail.ts is a copy of the server's file).
// Each recipient gets their own id in the address, so the preview shows its shape.
export const EmailPreview = ({ name, invitationText, lang }: { name: string; invitationText: string; lang: "en" | "no" }) => {
  const url = `${window.location.origin}/respond/?id=…`;
  const emailContent = renderInvitationContent({ lang, candidate: name, message: invitationText, url });

  return <div className={styles.preview} onClickCapture={preventLinkClick} dangerouslySetInnerHTML={{ __html: emailContent }} />;
};
